import { render, staticRenderFns } from "./Travels.vue?vue&type=template&id=58492c00&"
import script from "./Travels.vue?vue&type=script&lang=ts&"
export * from "./Travels.vue?vue&type=script&lang=ts&"
import style0 from "./Travels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports